import React, { useEffect, useState } from "react";
import Nvabar from "./Nvabar";
import Card from "./Card";
import "./Blogp.css";
import { Link, useParams } from "react-router-dom";
import Cookies from "js-cookie";
import axios from "axios";
import Card3 from "./Card3";
import Card4 from "./Card4";
const Blogp = () => {
  //attributes
  let params = useParams();
  const [Tag, setTag] = useState("Tech");
  const [results, setResults] = useState([]);
  const token = Cookies.get("token");

  //API Call

  useEffect(() => {
    console.log(params.type);
    request(params.type);
  }, [params.type]);

  const request = async (name) => {
    try {
      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const { data } = await axios.get(
        `${process.env.REACT_APP_URL}allpost${name}`,
        config
      );
      await setResults(data);
    } catch (err) {
      console.log(err.message);
    }
  };

  //return

  return (
    <div>
      <Nvabar />
      <div className="blog_wrapper">
        <div className="heading">
          <h2>{" " + params.type + " "}</h2>
        </div>
        <div className="posts">
          {results.map((item) => {
            return (
              <Link to={"/read/" + item._id}>
                <Card4
                  key={item.id}
                  Content={item.Content}
                  Title={item.Title}
                  Tag={item.Tag}
                  image={item.image}
                />
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Blogp;
